module.exports = __webpack_public_path__ + "static/media/person_double_lg_gold.eb643bd3.png";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/person_double_lg_gold.png
// module id = 180
// module chunks = 0